<template>
  <SkeletonAnimatedPlaceholder height="100%" width="100%" borderRadius="14px" />
</template>
